enum ESubscriberType {
  PART = 'part',
  WITNESS = 'witness',
}

export default ESubscriberType;
